import script from "./SwitchCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./SwitchCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./SwitchCheckbox.vue?vue&type=style&index=0&id=7b925042&lang=scss"

const __exports__ = script;

export default __exports__